__turbopack_context__.v({
  "checkIcon": "AiInRecruitingImpactSection-module__kKkUta__checkIcon",
  "impactSection": "AiInRecruitingImpactSection-module__kKkUta__impactSection",
  "itemText": "AiInRecruitingImpactSection-module__kKkUta__itemText",
  "list": "AiInRecruitingImpactSection-module__kKkUta__list",
  "listItem": "AiInRecruitingImpactSection-module__kKkUta__listItem",
  "sectionSubtitle": "AiInRecruitingImpactSection-module__kKkUta__sectionSubtitle",
  "sectionTitle": "AiInRecruitingImpactSection-module__kKkUta__sectionTitle",
});
